var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.944 10.5317C32.1739 7.82642 33.1942 8.37521 32.9005 11.3742C32.9005 11.3742 31.6715 21.3066 29.9787 30.1414C29.6464 31.8728 29.0976 35.382 25.4879 33.0863C24.715 32.5994 19.714 29.2216 17.1092 27.4361C14.8444 25.8902 16.3362 24.6457 17.1942 23.7646L25.2947 15.9346C25.8821 15.3858 25.1787 14.7598 24.6222 15.1617C24.6222 15.1617 13.9633 22.3578 13.4068 22.667C12.0618 23.4399 10.9643 24.4525 8.18938 23.6332C5.4145 22.8139 2.70918 22.296 2.70918 21.1598C2.70918 20.2399 4.63382 19.6139 7.59421 18.3153C13.5304 15.695 25.944 10.5317 25.944 10.5317Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.209a23832c12ac45670da37c93ed7c98.svg";
export { ForwardRef as ReactComponent };